import React, { useEffect, useState } from "react";
import { Modal, Checkbox, InputNumber, Button } from "antd";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import { getPDFDocument} from "api/services/JobService";
import { TTextControlJobDetails } from "api/services/models/types";

interface PrintModalProps {
  isVisible: boolean;
  handleClose: () => void;
  strSelectedJobs: string[];
  source: string;
}

const PrintModal: React.FC<PrintModalProps> = ({
  isVisible,
  handleClose,
  strSelectedJobs,
  source
}) => {
  const [mergePrintChecked, setMergePrintChecked] = useState<boolean>(false);
  const [spaceBetweenDocuments, setSpaceBetweenDocuments] = useState<number | null>(0);
  const { webDUser, accountId } = useTDAuthentication();
  const userId = webDUser?.user.userId;
  const showMergeOptions = strSelectedJobs?.length > 1;

  useEffect(() => {
    if (isVisible) {
      if (showMergeOptions) {
        const mergeCheckbox = localStorage.getItem("mergePrintCheckbox") === "true";
        const spaceValue = localStorage.getItem("spaceBetweenDocumentsForPrint");

        setMergePrintChecked(mergeCheckbox);
        setSpaceBetweenDocuments(spaceValue ? parseInt(spaceValue) : 0);
      } else {
        handlePrint();
        return;
      }
    } else {
      setMergePrintChecked(false);
      setSpaceBetweenDocuments(0);
    }
  }, [isVisible]);

  const savePrintSettings = () => {
    localStorage.setItem("mergePrintCheckbox", JSON.stringify(mergePrintChecked));
    localStorage.setItem(
      "spaceBetweenDocumentsForPrint",
      spaceBetweenDocuments?.toString() || "0"
    );
  };

  const handlePrint = async () => {
    if (showMergeOptions) {
      savePrintSettings();
    }

    const spaceBetween = mergePrintChecked ? spaceBetweenDocuments : 0;

    try {
      const jobDetails: TTextControlJobDetails = {
        jobIds: strSelectedJobs,
        accountId:  accountId ?? "",
        userId: userId ?? "",
        jobAction: "Print",
        connectionId: null,
        mergeDetails: {
          isMerge: mergePrintChecked,
          noOfLines: spaceBetween ?? 0
        }
      };
      const { blob, filename } = await getPDFDocument(jobDetails);
      const url = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const newWindow = window.open(url, "_blank");

      if (!newWindow) {
        alert("Please allow popups for this website");
      } else {
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);
      }
    } catch (error) {
      console.error("Error occurred while opening the print page:", error);
    }

    handleClose();
  };

  return (
    <>
      {showMergeOptions && (
        <Modal
          title="Print Settings"
          open={isVisible}
          onCancel={handleClose}
          footer={null}
          className="custom-modal"
          centered={true}>
          <div>
            <Checkbox
              checked={mergePrintChecked}
              onChange={e => setMergePrintChecked(e.target.checked)}
              style={{ fontSize: "12px" }}>
              Merge Files
            </Checkbox>
            <div
              style={{ display: "flex", justifyContent: "space-between", marginTop: "12px" }}>
              <div style={{ flex: 1, marginRight: "10px", width: "301px", height: "40px" }}>
                <label
                  htmlFor="no-of-lines"
                  style={{
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "4px"
                  }}>
                  Lines of space between documents
                </label>
                <InputNumber
                  id="no-of-lines"
                  disabled={!mergePrintChecked}
                  value={spaceBetweenDocuments}
                  onChange={value =>
                    setSpaceBetweenDocuments(value !== undefined ? value : null)
                  }
                  style={{ border: "1px solid #7777774D", width: "50%" }}
                  placeholder="Space Between Documents"
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: "40px", display:"flex", justifyContent:"flex-end" }}>
            <Button type="primary" onClick={handlePrint}>
              Print
            </Button>
            <Button style={{ marginLeft: "10px" }} onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default PrintModal;
